import { formatDateToDisplay } from "../../../generalFunctions";

const getTnCHtml = (quotationDetails) => {
  const tncRowsHtml = quotationDetails.terms_conditions.map(
    (condition) =>
      `<li style="font-size: 12px;"><span style="font-size: 12px;">${condition.text}</span></li>`
  );
  return tncRowsHtml.toString().replaceAll(",", "");
};

const getSpecificationHtml = (product_specifications) => {
  const specificationRowsHtml = product_specifications?.map(
    (specification) =>
      `<div><span style="font-size: 12px; margin-right:5px">${specification.parameter}:</span><span style="font-size: 12px;">${specification.specifications}</span></div>`
  );
  return specificationRowsHtml?.toString().replaceAll(",", "");
};

const formatMultilineText = (text) => {
  if (!text) return "";
  return text.replace(/\n/g, "<br>");
};

export const getQuotationHtml = (quotationDetails) => {
  return `<p style="line-height: 1.2; text-align: center; margin-top: 0pt; margin-bottom: 0pt;"><strong><span style="font-size: 14pt; font-family: 'Times New Roman', serif;"><img src=${require("../../../assets/images/authorization-letter-head.png")} alt="Authorization Letter Head" width="100%" height="auto"> </span></strong></p>
<p style="line-height: 1.2; text-align: center; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%; height: 76.4px;" border="0">
  <colgroup>
    <col style="width: 50%;">
    <col style="width: 50%;">
  </colgroup>
  <tbody>
    <tr style="height: 76.4px;">
      <td><span style="font-size: 14px;font-weight:bold;">&nbsp;To,</span><br><span style="font-size: 14px;font-weight:bold;">&nbsp;${quotationDetails.customer_name
    }</span><br>
    ${quotationDetails.organisation ? `<span style="font-size: 14px;font-weight:bold;">&nbsp;${quotationDetails.organisation}</span><br>` : ""}
      ${quotationDetails.shipping_address
      ? `<span style="font-size: 14px;font-weight:bold;">&nbsp;${quotationDetails.shipping_address}</span><br>`
      : ""
    }${quotationDetails.shipping_city
      ? `<span style="font-size: 14px;font-weight:bold;">&nbsp;${quotationDetails.shipping_city}</span>`
      : ""
    }${quotationDetails.shipping_state
      ? `<span style="font-size: 14px;font-weight:bold;">,&nbsp;${quotationDetails.shipping_state}</span><br>`
      : ""
    }${quotationDetails.shipping_country
      ? `<span style="font-size: 14px;font-weight:bold;">&nbsp;${quotationDetails.shipping_country}</span>`
      : ""
    }${quotationDetails.shipping_zipcode
      ? `<span style="font-size: 14px;font-weight:bold;">,&nbsp;${quotationDetails.shipping_zipcode}</span>`
      : ""
    }</td>
      <td style="text-align: right;"><span style="font-size: 14px;font-weight:bold;">Quotation No: <b>${quotationDetails.quotation_number
    }</b><br/> Date: ${formatDateToDisplay(
      quotationDetails.created_on
    )} </span></td>
    </tr>
  </tbody>
</table>
<p style="text-align: left;">&nbsp;</p>
<table style="border-collapse: collapse; width: 100%; border-width: 1px;" border="1">
  <colgroup>
    <col style="width: 50%;">
    <col style="width: auto;">
    <col style="width: auto;">
    <col style="width: auto;">
    <col style="width: auto;">
  </colgroup>
  <tbody>
    <tr>
      <td style="text-align: center; padding: 15px;font-weight:bold;">Description&nbsp;</td>
      <td style="text-align: center; padding: 15px;font-weight:bold;">Qty</td>
      <td style="text-align: center; padding: 15px;font-weight:bold;">Price</td>
      <td style="text-align: center; padding: 15px;font-weight:bold;">Amount</td>
    </tr>
    ${quotationDetails.product_details
      .map(
        (product) =>
          `<tr style="page-break-inside: avoid;">
      <td style="padding: 15px;">
        <p><strong><span style="font-size: 16px;">${product.product_name
          }</span><span style="font-size: 15px;"> </span></strong></p>
       <p><span style="font-size: 14px;">${getSpecificationHtml(product.specifications)}</span></p>
      </td>
      <td style="padding: 15px;">${product.quantity}</td>
      <td style="padding: 15px;">$${parseFloat(product.price).toFixed(2)}</td>
      <td style="padding: 15px;">$${parseFloat(product.amount).toFixed(2)}</td>
    </tr>`
      )
      .toString()
      .replaceAll(",", "")}
  </tbody>
</table>
<table style="border-collapse: collapse; width: 100%; border-width: 1px; page-break-inside: avoid;" border="1">
  <colgroup>
    <col style="width: 40%;">
    <col style="width: auto;">
  </colgroup>
  <tbody>
    <tr>
      <td style="text-align: right; padding: 15px;font-weight:bold;">Description&nbsp;</td>
      <td style="text-align: right; padding: 15px;font-weight:bold;">Amount</td>
    </tr>
     <tr>
      <td style="text-align: right; padding: 15px;font-weight:bold;">Subtotal</td>
      <td style="padding: 15px;text-align: right;">$${parseFloat(
        quotationDetails.total_item_amount
      ).toFixed(2)} </td>  
    </tr>
      <tr>
       <td style="text-align: right; padding: 15px;font-weight:bold;">(-) Discount</td>
       <td style="padding: 15px;text-align: right;">$${quotationDetails.total_discount_amount ||
    (quotationDetails.total_discount_percent
      ? (
        (quotationDetails.total_item_amount *
          parseFloat(quotationDetails.total_discount_percent)) /
        100
      ).toFixed(2)
      : "0.00")
    }</td>
    </tr>
     <tr>
 <td style="text-align: right; padding: 15px;font-weight:bold;">(+) Shipping &amp; Handling Charges</td>
        <td style="padding: 15px;text-align: right;">${quotationDetails.shipping
      ? "$" + parseFloat(quotationDetails.shipping).toFixed(2)
      : "As Applicable"
    } </td>
 </tr>
     <tr>
 <td style="text-align: right; padding: 15px;font-weight:bold;">(+) Bank Charges </td>
         <td style="padding: 15px;text-align: right;">${quotationDetails.bank_charges
      ? "$" + parseFloat(quotationDetails.bank_charges).toFixed(2)
      : "As Applicable"
    }</td>
 </tr>
     <tr>
<td style="text-align: right; padding: 15px;font-weight:bold;">(+) Adjustment</td>
          <td style="padding: 15px;text-align: right;">${quotationDetails.adjustment ? parseFloat(quotationDetails.adjustment).toFixed(2) : "$ 0.00"
    }</td>
     </tr>
     <tr>
<td style="text-align: right; padding: 15px;font-weight:bold;">Grand Total</td>
           <td style="padding: 15px;font-weight:bold;text-align: right;">$${parseFloat(quotationDetails.total).toFixed(2)
    }</td>
    </tr>
  </tbody>
</table>
<table style="border-collapse: collapse; width: 100%; height: 367.2px;page-break-inside: avoid;" border="0">
  <colgroup>
    <col style="width: 100%;">
  </colgroup>
  <tbody>
    <tr style="height: 367.2px;">
      <td style="padding-left: 15px;padding-bottom: 5px;">
        <p><strong><span style="font-size: 14px;">Terms and Conditions </span></strong></p>
        <p><strong><span style="font-size: 14px;">Cenvance Innovations Ltd</span></strong></p>
        <ul>
          ${getTnCHtml(quotationDetails)}
        </ul>
        <div style="margin-top: 40px;">
          <div style="height: 60px; border-bottom: 1px solid #000; width: 200px; margin-bottom: 5px;"></div>
          <p><strong><span style="font-size: 11px;">Authorized Signatory</span></strong></p>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<p style="text-align: left;">&nbsp;</p>`;
};
